"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseRecommendationResponse = void 0;
var _constants = require("../../utils/constants");
var _utils = require("../../utils/utils");
var _services = require("../../services");
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _lodash2 = _interopRequireDefault(require("lodash.groupby"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var config = {};
var getRecommendationTier = function getRecommendationTier(recommendationItem) {
  return recommendationItem.category.find(function (categoryItem) {
    return categoryItem['@type'] === 'tier';
  }).id;
};
var formatValueText = function formatValueText(groupedValues) {
  var textValue = '';
  Object.entries(groupedValues).forEach(function (_ref, index) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value[0] >= _constants.UNLIMITED_VALUE) return textValue += _services.locale.localeString("Specs.unlimited");
    if (key !== 'undefined' && key !== '') {
      var values = value.length > 1 ? value.join('/') : value[0];
      textValue += values ? "".concat(values, " ").concat(_services.locale.localeString("Units.".concat(key), key)) : '';
      if (index !== Object.entries(groupedValues).length - 1) {
        textValue += ',';
      }
    } else {
      var _values = value.length > 1 ? value.join(',') : value[0];
      textValue += "".concat(_values || '');
    }
  });
  return textValue;
};
var groupByUnit = function groupByUnit(characteristicValues) {
  return characteristicValues.reduce(function (group, value) {
    var _group$unitOfMeasure;
    var unitOfMeasure = value.unitOfMeasure;
    group[unitOfMeasure] = (_group$unitOfMeasure = group[unitOfMeasure]) !== null && _group$unitOfMeasure !== void 0 ? _group$unitOfMeasure : [];
    group[unitOfMeasure].push(value.value);
    group[unitOfMeasure].sort(function (a, b) {
      return a - b;
    });
    return group;
  }, {});
};
var parseProductCharacteristic = function parseProductCharacteristic(characteristic, specGroups) {
  var _characteristic$chara, _characteristic$chara2, _groupedCharacteristi;
  var iconName = _constants.CHARACTERISTIC_ICON_MAP[characteristic.name] || 'mobile';
  var groupedValues = groupByUnit(characteristic.value);
  var valueText = formatValueText(groupedValues);
  var fullText = "".concat((0, _utils.capitalize)(characteristic.name), ": ").concat(valueText);
  var groups = (_characteristic$chara = (_characteristic$chara2 = characteristic.characteristicRelationship) === null || _characteristic$chara2 === void 0 ? void 0 : _characteristic$chara2.map(function (item) {
    return item.id;
  })) !== null && _characteristic$chara !== void 0 ? _characteristic$chara : [];
  var groupedCharacteristic = specGroups.map(function (specGroup) {
    return specGroup.characteristics.find(function (spec) {
      var _characteristic$chara3, _characteristic$chara4;
      return spec.name === characteristic.name && (((_characteristic$chara3 = characteristic.characteristicRelationship) === null || _characteristic$chara3 === void 0 ? void 0 : _characteristic$chara3.some(function (charGroup) {
        return charGroup.id === specGroup.name;
      })) || !((_characteristic$chara4 = characteristic.characteristicRelationship) !== null && _characteristic$chara4 !== void 0 && _characteristic$chara4[0]));
    }) && specGroup;
  }).filter(function (el) {
    return el !== undefined;
  });
  var fullSpecGroup = groupedCharacteristic === null || groupedCharacteristic === void 0 ? void 0 : (_groupedCharacteristi = groupedCharacteristic[0]) === null || _groupedCharacteristi === void 0 ? void 0 : _groupedCharacteristi.name;
  return _objectSpread(_objectSpread({}, characteristic), {}, {
    groups: groups,
    fullSpecGroup: fullSpecGroup,
    iconName: iconName,
    valueText: valueText,
    fullText: fullText
  });
};
var parseFilterCharacteristic = function parseFilterCharacteristic(characteristic, product) {
  if (characteristic) {
    return _objectSpread(_objectSpread({}, characteristic), {}, {
      variantId: product.id
    });
  }
};
var getProductCharacteristic = function getProductCharacteristic(product, specGroups) {
  return function (characteristicName) {
    var characteristic = product.productCharacteristic.find(function (char) {
      return char.name === characteristicName;
    });
    return characteristic && parseProductCharacteristic(characteristic, specGroups);
  };
};
var getMainCharacteristics = function getMainCharacteristics(characteristics) {
  var _config = config,
    topFeaturesListConfig = _config.topFeatures;
  var DEFAULT_ORDER = 9999;
  var topFeaturesConfig = {};
  topFeaturesListConfig.forEach(function (feature, index) {
    if (topFeaturesConfig[feature.name] === undefined) {
      topFeaturesConfig[feature.name] = {
        order: index,
        icon: feature.icon
      };
    }
  });
  return characteristics.filter(function (characteristic) {
    return characteristic.groups.includes('topFeature');
  }).map(function (characteristic) {
    var _topFeaturesConfig$ch;
    return _objectSpread(_objectSpread({}, characteristic), {}, {
      iconName: ((_topFeaturesConfig$ch = topFeaturesConfig[characteristic.name]) === null || _topFeaturesConfig$ch === void 0 ? void 0 : _topFeaturesConfig$ch.icon) || characteristic.iconName
    });
  }).sort(function (spec1, spec2) {
    var _topFeaturesConfig$sp, _topFeaturesConfig$sp2, _topFeaturesConfig$sp3, _topFeaturesConfig$sp4;
    var specOrder1 = (_topFeaturesConfig$sp = (_topFeaturesConfig$sp2 = topFeaturesConfig[spec1.name]) === null || _topFeaturesConfig$sp2 === void 0 ? void 0 : _topFeaturesConfig$sp2.order) !== null && _topFeaturesConfig$sp !== void 0 ? _topFeaturesConfig$sp : DEFAULT_ORDER;
    var specOrder2 = (_topFeaturesConfig$sp3 = (_topFeaturesConfig$sp4 = topFeaturesConfig[spec2.name]) === null || _topFeaturesConfig$sp4 === void 0 ? void 0 : _topFeaturesConfig$sp4.order) !== null && _topFeaturesConfig$sp3 !== void 0 ? _topFeaturesConfig$sp3 : DEFAULT_ORDER;
    return specOrder1 - specOrder2;
  });
};
var getGroupedCharacteristics = function getGroupedCharacteristics(characteristics) {
  var _config2 = config,
    specGroupsListConfig = _config2.specGroups;
  var DEFAULT_ORDER = 9999;
  var groupConfig = {};
  var specConfig = {};
  var groupedSpecs = [];
  specGroupsListConfig.forEach(function (group, index) {
    if (groupConfig[group.name] === undefined) {
      groupConfig[group.name] = {
        order: index
      };
    }
    group.characteristics.forEach(function (characteristic, index) {
      if (specConfig[characteristic.name] === undefined) {
        specConfig[characteristic.name] = {
          order: index
        };
      }
    });
  });
  var specsWithGroups = characteristics.filter(function (spec) {
    return spec.fullSpecGroup && groupConfig[spec.fullSpecGroup] && spec.value !== undefined;
  });
  var groups = (0, _lodash2.default)(specsWithGroups, function (spec) {
    return spec.fullSpecGroup;
  });
  groupedSpecs.push.apply(groupedSpecs, _toConsumableArray(Object.entries(groups).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      groupName = _ref4[0],
      specs = _ref4[1];
    return {
      name: groupName,
      specs: specs.sort(function (spec1, spec2) {
        var _specConfig$spec1$nam, _specConfig$spec1$nam2, _specConfig$spec2$nam, _specConfig$spec2$nam2;
        var specOrder1 = (_specConfig$spec1$nam = (_specConfig$spec1$nam2 = specConfig[spec1.name]) === null || _specConfig$spec1$nam2 === void 0 ? void 0 : _specConfig$spec1$nam2.order) !== null && _specConfig$spec1$nam !== void 0 ? _specConfig$spec1$nam : DEFAULT_ORDER;
        var specOrder2 = (_specConfig$spec2$nam = (_specConfig$spec2$nam2 = specConfig[spec2.name]) === null || _specConfig$spec2$nam2 === void 0 ? void 0 : _specConfig$spec2$nam2.order) !== null && _specConfig$spec2$nam !== void 0 ? _specConfig$spec2$nam : DEFAULT_ORDER;
        return specOrder1 - specOrder2;
      })
    };
  }).sort(function (group1, group2) {
    var _groupConfig$group1$n, _groupConfig$group1$n2, _groupConfig$group2$n, _groupConfig$group2$n2;
    var groupOrder1 = (_groupConfig$group1$n = (_groupConfig$group1$n2 = groupConfig[group1.name]) === null || _groupConfig$group1$n2 === void 0 ? void 0 : _groupConfig$group1$n2.order) !== null && _groupConfig$group1$n !== void 0 ? _groupConfig$group1$n : DEFAULT_ORDER;
    var groupOrder2 = (_groupConfig$group2$n = (_groupConfig$group2$n2 = groupConfig[group2.name]) === null || _groupConfig$group2$n2 === void 0 ? void 0 : _groupConfig$group2$n2.order) !== null && _groupConfig$group2$n !== void 0 ? _groupConfig$group2$n : DEFAULT_ORDER;
    return groupOrder1 - groupOrder2;
  })));
  return groupedSpecs;
};
var mergeMainProductToVariants = function mergeMainProductToVariants(mainProduct) {
  var _mainProduct$productR, _mainProduct$productR2;
  (_mainProduct$productR = mainProduct.productRelationship) === null || _mainProduct$productR === void 0 ? void 0 : (_mainProduct$productR2 = _mainProduct$productR.filter(function (relationshipItem) {
    return relationshipItem.relationshipType === 'alternative';
  })) === null || _mainProduct$productR2 === void 0 ? void 0 : _mainProduct$productR2.forEach(function (relationshipItem) {
    var variant = relationshipItem.product;
    // merge characteristics
    mainProduct.productCharacteristic.forEach(function (characteristic) {
      var characteristicExists = variant.productCharacteristic.find(function (variantCharacteristic) {
        return variantCharacteristic.name === characteristic.name;
      });
      if (!characteristicExists) {
        variant.productCharacteristic.push((0, _utils.clone)(characteristic));
      }
    });

    // merge price
    if (!variant.productPrice) {
      variant.productPrice = (0, _utils.clone)(mainProduct.productPrice);
    }

    // merge product term
    if (!variant.productTerm) {
      variant.productTerm = mainProduct.productTerm ? (0, _utils.clone)(mainProduct.productTerm) : [];
    }
  });
};
var createFilterTree = function createFilterTree(variants, category) {
  if (category !== 'handset') {
    return;
  }
  /**
   * 1. Find unique colors
   * 2. For each color find its memory variants, sort them by value, add them as children to color
   * 3. Assign as default color variantId the first memory variantId
   */
  return (0, _lodash.default)(variants, function (variant) {
    var _variant$color$value$, _variant$color$value, _variant$color$value2;
    var defaultValue = (_variant$color$value$ = (_variant$color$value = variant.color.value) === null || _variant$color$value === void 0 ? void 0 : _variant$color$value.find(function (value) {
      return value.isDefault;
    })) !== null && _variant$color$value$ !== void 0 ? _variant$color$value$ : (_variant$color$value2 = variant.color.value) === null || _variant$color$value2 === void 0 ? void 0 : _variant$color$value2[0];
    return defaultValue.value;
  }).map(function (variant) {
    var _variant$color$value$2, _variant$color$value3, _variant$color$value4;
    var defaultValue = (_variant$color$value$2 = (_variant$color$value3 = variant.color.value) === null || _variant$color$value3 === void 0 ? void 0 : _variant$color$value3.find(function (value) {
      return value.isDefault;
    })) !== null && _variant$color$value$2 !== void 0 ? _variant$color$value$2 : (_variant$color$value4 = variant.color.value) === null || _variant$color$value4 === void 0 ? void 0 : _variant$color$value4[0];
    return {
      id: variant.color.id,
      name: variant.color.name,
      value: [defaultValue]
    };
  }).map(function (color) {
    return _objectSpread(_objectSpread({}, color), {}, {
      variants: variants.filter(function (variant) {
        var _variant$color, _variant$color$value5, _variant$color$value6, _variant$color$value7, _color$value$0$value, _variant$memory, _variant$memory$value;
        return (variant === null || variant === void 0 ? void 0 : (_variant$color = variant.color) === null || _variant$color === void 0 ? void 0 : (_variant$color$value5 = _variant$color.value) === null || _variant$color$value5 === void 0 ? void 0 : (_variant$color$value6 = _variant$color$value5.find(function (c) {
          return c.isDefault;
        })) === null || _variant$color$value6 === void 0 ? void 0 : (_variant$color$value7 = _variant$color$value6.value) === null || _variant$color$value7 === void 0 ? void 0 : _variant$color$value7.split('|')[1]) === ((_color$value$0$value = color.value[0].value) === null || _color$value$0$value === void 0 ? void 0 : _color$value$0$value.split('|')[1]) && (variant === null || variant === void 0 ? void 0 : (_variant$memory = variant.memory) === null || _variant$memory === void 0 ? void 0 : (_variant$memory$value = _variant$memory.value) === null || _variant$memory$value === void 0 ? void 0 : _variant$memory$value.find(function (m) {
          return m.isDefault;
        }));
      }).map(function (variant) {
        var _variant$memory2, _variant$memory2$valu;
        return {
          id: variant.memory.id,
          name: variant.memory.name,
          value: variant === null || variant === void 0 ? void 0 : (_variant$memory2 = variant.memory) === null || _variant$memory2 === void 0 ? void 0 : (_variant$memory2$valu = _variant$memory2.value) === null || _variant$memory2$valu === void 0 ? void 0 : _variant$memory2$valu.find(function (m) {
            return m.isDefault;
          }),
          variantId: variant.memory.variantId
        };
      }).sort(function (a, b) {
        return a.value - b.value;
      })
    });
  }).map(function (color) {
    var _color$variants$;
    return _objectSpread(_objectSpread({}, color), {}, {
      variantId: color === null || color === void 0 ? void 0 : (_color$variants$ = color.variants[0]) === null || _color$variants$ === void 0 ? void 0 : _color$variants$.variantId
    });
  });
};
var createVariant = function createVariant(product, attachment, category, specGroups) {
  var _getCharacteristic, _getCharacteristic2;
  var getCharacteristic = getProductCharacteristic(product, specGroups);
  var variantId = product.id;
  var media = attachment;
  var color = parseFilterCharacteristic(getCharacteristic('color'), product);
  var memory = parseFilterCharacteristic(getCharacteristic('memory'), product);
  var brand = (_getCharacteristic = getCharacteristic('brand')) === null || _getCharacteristic === void 0 ? void 0 : _getCharacteristic.value;
  var prices = product.productPrice.map(function (priceItem, index) {
    var _product$productTerm, _product$productTerm$, _product$productTerm2, _product$productTerm3;
    return {
      priceValue: priceItem.price.taxIncludedAmount.value,
      priceUnit: priceItem.price.taxIncludedAmount.unit,
      priceType: priceItem.priceType,
      durationAmount: (_product$productTerm = product.productTerm) === null || _product$productTerm === void 0 ? void 0 : (_product$productTerm$ = _product$productTerm[index]) === null || _product$productTerm$ === void 0 ? void 0 : _product$productTerm$.duration.amount,
      durationUnit: (_product$productTerm2 = product.productTerm) === null || _product$productTerm2 === void 0 ? void 0 : (_product$productTerm3 = _product$productTerm2[index]) === null || _product$productTerm3 === void 0 ? void 0 : _product$productTerm3.duration.units
    };
  }).sort(function (a, b) {
    return a.priceValue - b.priceValue;
  });
  var price = category === 'business-solution' ? prices : prices[0];
  var discountedPrice = prices.find(function (price) {
    return price.priceType === 'discount';
  });
  var characteristics = product.productCharacteristic.filter(function (characteristic) {
    return characteristic.value !== undefined;
  }).map(function (characteristic) {
    return parseProductCharacteristic(characteristic, specGroups);
  });
  var groupedCharacteristics = getGroupedCharacteristics(characteristics);
  var mainCharacteristics = getMainCharacteristics(characteristics);
  var matchValue = Math.floor(((_getCharacteristic2 = getCharacteristic('productScore')) === null || _getCharacteristic2 === void 0 ? void 0 : _getCharacteristic2.value) * 100);
  var matchSpecs = characteristics.filter(function (characteristic) {
    var _characteristic$chara5;
    return characteristic === null || characteristic === void 0 ? void 0 : (_characteristic$chara5 = characteristic.characteristicRelationship) === null || _characteristic$chara5 === void 0 ? void 0 : _characteristic$chara5.find(function (relationship) {
      return relationship.id === 'matchingSpec';
    });
  });
  return {
    variantId: variantId,
    media: media,
    brand: brand,
    color: color,
    memory: memory,
    price: price,
    discountedPrice: discountedPrice,
    characteristics: characteristics,
    groupedCharacteristics: groupedCharacteristics,
    mainCharacteristics: mainCharacteristics,
    matchValue: matchValue,
    matchSpecs: matchSpecs
  };
};
function sortImages(a, b) {
  var imageOrder = ['front', 'left', 'right', 'side', 'back'];
  return imageOrder.indexOf(a.name) - imageOrder.indexOf(b.name);
}
var createVariants = function createVariants(productRecommendation, category, specGroups) {
  var _mainProduct$productR3, _mainProduct$productR4, _mainProduct$productR5;
  var mainProduct = productRecommendation.recommendationItem[0].product;
  var attachment = productRecommendation.attachment.sort(sortImages);
  var mainVariant = createVariant(mainProduct, attachment, category, specGroups);
  mergeMainProductToVariants(mainProduct);
  var variants = (_mainProduct$productR3 = (_mainProduct$productR4 = mainProduct.productRelationship) === null || _mainProduct$productR4 === void 0 ? void 0 : (_mainProduct$productR5 = _mainProduct$productR4.filter(function (relationshipItem) {
    return relationshipItem.relationshipType === 'alternative';
  })) === null || _mainProduct$productR5 === void 0 ? void 0 : _mainProduct$productR5.map(function (relationshipItem) {
    return createVariant(relationshipItem.product, attachment, category, specGroups);
  })) !== null && _mainProduct$productR3 !== void 0 ? _mainProduct$productR3 : [];
  return [mainVariant].concat(_toConsumableArray(variants));
};
var parseRecommendationItem = function parseRecommendationItem(recommendationItem, category, specGroups) {
  var _recommendationItem$r;
  var tier = getRecommendationTier(recommendationItem);
  var productId = recommendationItem.id;
  var productName = recommendationItem.name;
  var productType = category;
  var variants = createVariants(recommendationItem, category, specGroups);
  var filterTree = createFilterTree(variants, category);
  var productRelationship = recommendationItem === null || recommendationItem === void 0 ? void 0 : (_recommendationItem$r = recommendationItem.recommendationItem[0]) === null || _recommendationItem$r === void 0 ? void 0 : _recommendationItem$r.product.productRelationship;
  return {
    tier: tier,
    productId: productId,
    productName: productName,
    productType: productType,
    variants: variants,
    selectedVariant: chooseSelectedVariant(variants) || variants[0],
    filterTree: filterTree,
    productRelationship: productRelationship
  };
};
var chooseSelectedVariant = function chooseSelectedVariant(variants) {
  return variants.find(function (variant) {
    var _variant$color2, _variant$color2$value, _variant$color2$value2;
    return variant === null || variant === void 0 ? void 0 : (_variant$color2 = variant.color) === null || _variant$color2 === void 0 ? void 0 : (_variant$color2$value = _variant$color2.value) === null || _variant$color2$value === void 0 ? void 0 : (_variant$color2$value2 = _variant$color2$value.find(function (c) {
      return c.isDefault == true;
    })) === null || _variant$color2$value2 === void 0 ? void 0 : _variant$color2$value2.value.split('|')[0];
  });
};
var getHandsetsFromResponse = function getHandsetsFromResponse(response) {
  return response.filter(function (item) {
    return item.category.find(function (categoryItem) {
      return categoryItem.id === 'handset';
    }) && item.category.find(function (categoryItem) {
      return categoryItem['@type'] === 'tier';
    });
  });
};
var getPlansFromResponse = function getPlansFromResponse(response) {
  return response.filter(function (item) {
    return item.category.find(function (categoryItem) {
      return categoryItem.id === 'plan';
    }) && item.category.find(function (categoryItem) {
      return categoryItem['@type'] === 'tier';
    });
  });
};
var getBroadbandsFromResponse = function getBroadbandsFromResponse(response) {
  return response.filter(function (item) {
    return item.category.find(function (categoryItem) {
      return categoryItem.id === 'broadband';
    }) && item.category.find(function (categoryItem) {
      return categoryItem['@type'] === 'tier';
    });
  });
};
var replaceRecommendedSolutionsWithAlternative = function replaceRecommendedSolutionsWithAlternative(businessSolutions, replacedProductsConfig) {
  var newAlternativeProduct = businessSolutions.find(function (product) {
    return replacedProductsConfig.map(function (rp) {
      return rp.recommended;
    }).includes(product.id);
  });
  var newRecommendedProduct = businessSolutions.find(function (product) {
    return replacedProductsConfig.map(function (rp) {
      return rp.alternative;
    }).includes(product.id);
  });
  if (newRecommendedProduct && newAlternativeProduct) {
    newAlternativeProduct.category.find(function (categoryItem) {
      return categoryItem['@type'] === 'tier';
    }).id = _constants.RECOMMENDATION_TIER.ALTERNATIVE;
    newRecommendedProduct.category.find(function (categoryItem) {
      return categoryItem['@type'] === 'tier';
    }).id = _constants.RECOMMENDATION_TIER.RECOMMENDED;
    var recommendedSolutionIndex = businessSolutions.findIndex(function (solution) {
      return solution.category.find(function (categoryItem) {
        return categoryItem['@type'] === 'tier';
      }).id === _constants.RECOMMENDATION_TIER.RECOMMENDED;
    });
    businessSolutions[recommendedSolutionIndex] = newAlternativeProduct;
    var alternativeSolutionIndex = businessSolutions.findIndex(function (solution) {
      return solution.category.find(function (categoryItem) {
        return categoryItem['@type'] === 'tier';
      }).id === _constants.RECOMMENDATION_TIER.ALTERNATIVE;
    });
    businessSolutions[alternativeSolutionIndex] = newRecommendedProduct;
  }
  return businessSolutions;
};
var getBusinessSolutionsFromResponse = function getBusinessSolutionsFromResponse(response, replacedProductsConfig) {
  var businessSolutions = response.filter(function (item) {
    return item.category.find(function (categoryItem) {
      return categoryItem.id === 'business-solution';
    }) && item.category.find(function (categoryItem) {
      return categoryItem['@type'] === 'tier';
    });
  });
  return replaceRecommendedSolutionsWithAlternative(businessSolutions, replacedProductsConfig);
};
var parseRecommendationResponse = function parseRecommendationResponse(response, productCatalogConfig, replacedRecommendedProductWithAlternative) {
  config = productCatalogConfig;
  var responseHandsets = getHandsetsFromResponse(response);
  var responsePlans = getPlansFromResponse(response);
  var responseBroadbands = getBroadbandsFromResponse(response);
  var responseBusinessSolutions = getBusinessSolutionsFromResponse(response, replacedRecommendedProductWithAlternative);
  var handsets = responseHandsets.map(function (recommendationProduct) {
    return parseRecommendationItem(recommendationProduct, 'handset', config.specGroups);
  });
  var plans = responsePlans.map(function (recommendationProduct) {
    return parseRecommendationItem(recommendationProduct, 'plan', config.specGroups);
  });
  var broadbands = responseBroadbands.map(function (recommendationProduct) {
    return parseRecommendationItem(recommendationProduct, 'broadband', config.specGroups);
  });
  var businessSolutions = responseBusinessSolutions.map(function (recommendationProduct) {
    return parseRecommendationItem(recommendationProduct, 'business-solution', config.specGroups);
  });
  return {
    handsets: handsets,
    plans: plans,
    broadbands: broadbands,
    businessSolutions: businessSolutions
  };
};
exports.parseRecommendationResponse = parseRecommendationResponse;